import { render, staticRenderFns } from "./leftT-temp3.vue?vue&type=template&id=58bb5e90&scoped=true"
import script from "./leftT-temp3.vue?vue&type=script&lang=js"
export * from "./leftT-temp3.vue?vue&type=script&lang=js"
import style0 from "./leftT-temp3.vue?vue&type=style&index=0&id=58bb5e90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb5e90",
  null
  
)

export default component.exports